var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifiedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0002 2.3335C13.8252 2.3335 2.3335 13.8252 2.3335 28.0002C2.3335 42.1752 13.8252 53.6668 28.0002 53.6668C42.1752 53.6668 53.6668 42.1752 53.6668 28.0002C53.6668 13.8252 42.1752 2.3335 28.0002 2.3335ZM39.1255 23.6602C39.3304 23.426 39.4863 23.1532 39.5842 22.8579C39.6821 22.5626 39.7199 22.2506 39.6955 21.9405C39.671 21.6303 39.5848 21.3281 39.4418 21.0518C39.2989 20.7754 39.1021 20.5305 38.8631 20.3313C38.6241 20.1321 38.3477 19.9827 38.0501 19.892C37.7525 19.8012 37.4397 19.7709 37.1302 19.8028C36.8207 19.8346 36.5207 19.9281 36.2479 20.0776C35.9751 20.2272 35.7349 20.4298 35.5415 20.6735L25.5082 32.7112L20.3165 27.5172C19.8764 27.0921 19.287 26.8569 18.6752 26.8623C18.0634 26.8676 17.4782 27.113 17.0456 27.5456C16.613 27.9782 16.3676 28.5634 16.3623 29.1752C16.3569 29.787 16.5921 30.3764 17.0172 30.8165L24.0172 37.8165C24.2464 38.0456 24.5209 38.2245 24.8231 38.3416C25.1253 38.4588 25.4487 38.5117 25.7725 38.497C26.0963 38.4823 26.4134 38.4003 26.7038 38.2562C26.9941 38.1121 27.2513 37.9091 27.4588 37.6602L39.1255 23.6602Z",
    fill: "#219653"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verified-icon.63efbb57c4a751b2db65ee6f675cec05.svg";
export { ForwardRef as ReactComponent };